/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { IconButton, Typography, useTheme } from "@mui/material";
import { UploadFile } from "@mui/icons-material";
import { tokens } from "../../../theme";
import { toKebabCase, toPascalCase } from "../../../utils/helperFunctions";

const ScriptUploadInput = ({ scriptName, setScript }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [name, setName] = useState("");

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileContent = await file.text();
    setName(file.name);

    setScript(fileContent, file.name);
  };

  return (
    <>
      <input
        accept=".sh"
        type="file"
        id={`upload-${toKebabCase(scriptName)}-script`}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor={`upload-${toKebabCase(scriptName)}-script`}>
        <IconButton component="span" color="secondary">
          <UploadFile />
        </IconButton>
      </label>
      <Typography variant="h6" sx={{ mt: 1 }}>
        {toPascalCase(scriptName)} Script:{" "}
        {name ? (
          <Typography sx={{ color: colors.green[500], display: "inline" }}>
            {name}
          </Typography>
        ) : (
          "No file selected!"
        )}
      </Typography>
    </>
  );
};

export default ScriptUploadInput;
